import { axiosInstance } from '@/lib/utils';
import { endpoints } from '@/api';
import type {
  PaginatedRequestResponse,
  ShippingMethod,
  RequestResponse,
} from '@/types';

export const fetchShippingMethods = async () => {
  const response = await axiosInstance<
    PaginatedRequestResponse<ShippingMethod[]>
  >(endpoints.shipping);
  return response.data.data.data;
};

export const fetchShippingMethod = async (id: number) => {
  const response = await axiosInstance<RequestResponse<ShippingMethod>>(
    `${endpoints.shipping}/${id}`
  );
  return response.data.data;
};
